import React from "react";
import { object, number } from "prop-types";
// import { useSelector } from "react-redux";
// import get from "lodash/get";
// import { WithLazy, ResponsiveImage, StoryElement } from "@quintype/components";

import StoryHeader from "../story-header";
import { StoryCard } from "../story-elements";
import Tags from "../story-elements/tags";
import StorySideBar from "../story-sidebar";

import "./listcle.m.css";
import MoreNews from "../story-elements/more-news";

const ListcleStoryTemplate = ({ story, index }) => {
  return (
    <>
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} />
            <div id={`story-content-${story.id}`} className="story-cards">
              {story.cards.map((card, index) => (
                <div key={index}>
                  <div styleName="decimal"> {index === 0 ? "Introduction" : index}</div>
                  <StoryCard card={card} story={story} key={index} />
                </div>
              ))}
            </div>
            <Tags story={story} />
          </div>
        </div>

        <div className="side-story-section">
          <StorySideBar index={index} story={story} />
        </div>
        <div className="more-news-section">
          <MoreNews story={story} />
        </div>
      </div>
    </>
  );
};

ListcleStoryTemplate.propTypes = {
  story: object,
  index: number
};

const ListcleStory = (props) => {
  return <ListcleStoryTemplate story={props.story} index={props.index} />;
};

ListcleStory.propTypes = {
  story: object,
  index: number
};

export default ListcleStory;
